import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="toggle-loom"
export default class extends Controller {
  static targets = [
    'button',
    'content',
  ]

  declare readonly buttonTarget: HTMLButtonElement
  declare readonly contentTarget: HTMLElement

  toggleContent () {
    this.contentTarget.classList.toggle('hidden')
    this.buttonTarget.classList.toggle('hidden')
  }
}
